// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__9TjT2","label":"CategoryService_label__1-GKZ","location":"CategoryService_location__1Im1q"};